module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container properties"
  }, [_c('auto-edit-table', {
    attrs: {
      "defines": _vm.$defines.property,
      "unstackable": "unstackable",
      "data": _vm.filtered,
      "title": "库存信息",
      "pagesize": 30
    }
  }, [_c('filters-group', {
    attrs: {
      "slot": "afterTitle",
      "data": _vm.properties,
      "result": _vm.filtered
    },
    on: {
      "update:result": function($event) {
        _vm.filtered = $event
      }
    },
    slot: "afterTitle"
  }, [_c('div', {
    staticClass: "ui two columns stackable form grid filters"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h4', [_vm._v("筛选")]), _c('filter-select', {
    attrs: {
      "filter": _vm.$defines.property.filters.select
    }
  })], 1), _c('div', {
    staticClass: "column"
  }, [_c('h4', [_vm._v("搜索")]), _c('filter-search', {
    attrs: {
      "filter": _vm.$defines.property.filters.search,
      "placeholder": "搜索..."
    }
  })], 1)])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50ec3703","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/pages/Properties.vue
// module id = 436
// module chunks = 0